/**
 * Textos das "Orientações para o jurídico" (E158.F3, GUS-191, ADR-0108 §2.6): a página do portal,
 * a área no caso do portal e a minuta da equipe. O conteúdo de cada risco vem do servidor; aqui
 * ficam os rótulos e as situações.
 */
export const ptBROrientacoes = {
  // E165.F2.T05 (HTML 6.8, GUS-191): no portal, o reservado se chama "Relatório de risco", com a
  // faixa de uso interno junto ao card, ao download, na prévia e no PDF.
  titulo: 'Relatório de risco',
  sobretituloCliente: 'Cliente',
  sobretituloEquipe: 'Trabalho / Equipe',
  aviso: 'Uso interno do banco e escritório autorizado. Não juntar aos autos.',
  avisoTitulo: 'Relatório para uso interno',
  avisoTexto:
    'Instruções para o trabalho do jurídico. O documento destinado ao processo é o exame.',
  versao: 'versão {versao}',
  rodada: 'rodada {rodada}',
  // E172.F5 (GUS-230 C3): a fórmula do documento (`orientacoes_reservadas_publico`), sem perito.
  conclusao: 'Conclusão do laudo: {estado}, {modo}, {estagio}.',
  pendente: 'PENDENTE (exame preliminar)',
  modo: { parte: 'modo PARTE', juizo: 'modo JUÍZO' },
  estagio: {
    proposta: 'proposta {rotulo} sujeita à revisão do assistente técnico',
    semProposta: 'sujeita à revisão do assistente técnico',
    definida: 'conclusão definida',
  },
  oQueFazer: 'O que fazer neste caso',
  oQueFazerTexto:
    'Providências na ordem de importância apurada na análise. O grau é técnico e não é probabilidade de resultado.',
  semRiscos:
    'Sem riscos identificados no alcance examinado nesta versão ({cobertura}). A busca foi executada e conferida; isso não afirma a inexistência de riscos fora desse alcance.',
  risco: {
    grau: {
      alto: 'Risco técnico alto',
      medio: 'Risco técnico médio',
      baixo: 'Risco técnico baixo',
    },
    providencia: 'Providência',
    motivo: 'Motivo',
    resposta: 'Resposta disponível',
    semResposta: 'Não há resposta técnica disponível no material examinado.',
    razao: 'Razão do grau',
    detalhes: 'Ver fonte e detalhes técnicos',
    fonte: 'Fonte',
    fundamento: 'Fundamento atingido',
    usoContrario: 'Uso possível pela parte contrária',
    natureza: 'Natureza',
    tambemNoLaudo: 'Também indicado no laudo.',
    soNesteRelatorio: 'Consta apenas neste relatório.',
    responsavel: 'Responsável',
    estado: 'Estado',
    identificador: 'Identificador',
  },
  estadoDoRisco: { em_aberto: 'em aberto' },
  natureza: {
    contraprova: 'Contraprova',
    limite_essencial: 'Limite essencial',
    limite_nao_decisivo: 'Limite do elemento',
    exigencia_legal: 'Exigência legal',
    diligencia_decisiva: 'Diligência decisiva',
    pendencia_normativa: 'Pendência normativa',
    tese_alternativa: 'Tese alternativa',
    item_nao_comprovado: 'Item não comprovado',
    reforco: 'Reforço da prova',
  },
  compartilhar: {
    titulo: 'Compartilhar com a equipe',
    texto:
      'O link abre este relatório na plataforma após login. O destinatário precisa ter acesso a este caso.',
    botao: 'Copiar link restrito',
    copiado: 'Link copiado. O destinatário precisa ter acesso a este caso.',
    falhou:
      'Não foi possível copiar automaticamente. Selecione o link abaixo e copie com Ctrl+C (ou Cmd+C).',
    rotuloDoLink: 'Link restrito do relatório de risco',
  },
  fora: {
    titulo: 'Consulta fora da plataforma',
    baixar: 'Baixar relatório de risco · PDF',
    baixando: 'Preparando o PDF…',
    erro: 'Não foi possível baixar o relatório de risco. Tente novamente.',
  },
  voltarAoCaso: 'Voltar ao caso',
  verLaudo: 'Ver o exame do caso',
  carregando: 'Carregando o relatório de risco…',
  naoLiberadas:
    'O relatório de risco deste caso ainda não foi liberado. Ele acompanha o exame assinado.',
  erro: 'Não foi possível carregar o relatório de risco. Tente novamente.',
  semPermissao: 'Você não tem acesso a este relatório.',
  naoEncontrado: 'Caso não encontrado ou fora do seu alcance.',
  tentarDeNovo: 'Tentar de novo',
  equipe: {
    titulo: 'Orientações para o jurídico — minuta da equipe',
    subtitulo:
      'O que o banco e o escritório do caso recebem com o laudo assinado: as providências do reservado, na classificação da análise.',
    abrir: 'Orientações para o jurídico',
    voltar: 'Voltar ao resultado',
    situacao: {
      nao_aplicavel:
        'Este caso não tem orientações reservadas: elas existem só no exame eletrônico em modo PARTE.',
      indisponivel: 'As orientações não podem ser compostas agora: {motivo}.',
      minuta:
        'Minuta, ainda não liberada. As orientações são liberadas ao banco e ao escritório do caso junto com a assinatura do laudo.',
      nao_liberada:
        'O laudo desta versão foi assinado, mas as orientações não foram liberadas. Libere de novo.',
      liberada: 'Liberadas ao banco e ao escritório do caso com o laudo assinado.',
    },
    /** E158.F3.C01: o porquê da indisponibilidade, em texto de tela — o código fica fora da vista. */
    motivos: {
      aguardando_processamento: 'a análise do caso ainda está em processamento',
      pendencia_tecnica: 'a análise do caso tem uma pendência técnica a resolver antes',
      em_conferencia: 'a análise do caso ainda está em conferência',
      reservado_fora_do_modo_parte: 'as orientações existem só no exame em modo PARTE',
      busca_nao_executada: 'a busca de riscos do caso ainda não foi feita',
      busca_nao_conferida: 'a busca de riscos do caso ainda não foi conferida',
      risco_sem_classificacao: 'há risco do caso ainda sem classificação',
      // E172.F17.T07: com a análise facial em curso, a minuta espera o parecer novo
      analise_facial_em_andamento: 'a análise morfológica facial do caso está em andamento',
    } as Record<string, string>,
    motivoDesconhecido: 'há uma pendência na análise do caso que impede compor as orientações',
    final: 'Última liberação: versão {versao}, {data} ({situacao}).',
    situacaoDoFinal: { vigente: 'vigente', desatualizado: 'desatualizada' },
    baixarMinuta: 'Baixar minuta — PDF',
    liberarDeNovo: 'Liberar de novo',
    liberando: 'Liberando…',
    erroDaAcao: {
      sem_permissao: 'A minuta das orientações é da equipe que atende o caso.',
      nao_encontrado: 'Caso não encontrado ou fora do seu alcance.',
      nao_aplicaveis: 'Este caso não tem orientações reservadas.',
      sem_laudo_assinado: 'O laudo desta versão ainda não foi assinado.',
      // E159.F2: a liberação só sai com a conferência das orientações aprovada.
      nao_conferidas:
        'As orientações não passaram na conferência. Veja os apontamentos em "Conferir laudo e orientações".',
      // E170.F4.C04 (GUS-229): o final do relatório de risco é do banco do caso.
      instituicao_nao_cadastrada:
        'O caso não tem banco cadastrado: a prévia mostra a pendência e o relatório final só sai com o banco do caso.',
      desatualizado: 'A análise mudou enquanto a ação rodava. Recarregue e tente de novo.',
      indisponiveis: 'As orientações não podem ser compostas agora.',
      indisponivel: 'Não foi possível concluir a ação. Tente novamente.',
    },
  },
};
